const URL_FUNCTIONS = "https://us-central1-gnp-agenda-sit.cloudfunctions.net";
const URL_SERVICES = "https://servicios-gipa-dot-gnp-agenda-sit.appspot.com/api/dev";

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyBg8Jvx_WfKokdop9aQnv_zuZF5xsoh5RQ",
    authDomain: "gnp-agenda-sit.firebaseapp.com",
    databaseURL: "https://gnp-agenda-sit.firebaseio.com",
    projectId: "gnp-agenda-sit",
    storageBucket: "gnp-agenda-sit.appspot.com",
    messagingSenderId: "552289166103",
    appId: "1:552289166103:web:c53929c74ffd385a884d52",
    measurementId: "G-TD3TW0XG85",
  },
  entradas: {
    cargar: `${URL_FUNCTIONS}/entradas/buscarEntradas`,
    relacionados: `${URL_FUNCTIONS}/entradas/relacionados`,
    consultarAcuerdoPorEntrada: `${URL_SERVICES}/despacho/consultarAcuerdoPorEntrada`,
    treeMap: `${URL_FUNCTIONS}/jerarquia/tree`,
    eliminar: `${URL_FUNCTIONS}/jerarquia/eliminar`,
  },
  usuarios: {
    nuevo: `${URL_FUNCTIONS}/usuarios/nuevo`,
    actualizar: `${URL_FUNCTIONS}/usuarios/actualizar`,
    borrar: `${URL_FUNCTIONS}/usuarios/borrar`,
    rol: `${URL_FUNCTIONS}/usuarios/rol`,
    actualizarMostrar: `${URL_FUNCTIONS}/usuarios/actualizarMostrar`,
  },
  folio: {
    genera: `${URL_FUNCTIONS}/foliador/generarFolio`,
  },
  catalogos: {
    getCatalogo: `${URL_SERVICES}/acuerdos/getCatalogo/`,
    consultaResponsables: `${URL_SERVICES}/acuerdos/getResponsablesFB`,
    formasEnvio: `${URL_SERVICES}/acuerdos/getCatFormaEnvio`,
    consultaResponsablesAll: `${URL_SERVICES}/acuerdos/getAllResponsablesFB`,
  },
  apiSearch: {
    busqueda: `${URL_FUNCTIONS}/apisearch/busqueda`,
    busquedaAvanzada: `${URL_FUNCTIONS}/apisearch/busquedaAvanzada`,
  },
  despacho: {
    consultarTemas:`${URL_SERVICES}/despacho/consultarTemas`,
    guardarTema:`${URL_SERVICES}/despacho/guardarTema`,
    relacionarEntrada:`${URL_SERVICES}/despacho/relacionarEntradaTemaDespacho`,
    terminarTema: `${URL_SERVICES}/despacho/terminarTemaDespacho`,
    consultarTemasPorEmpresa: `${URL_SERVICES}/despacho/consultarTemasPorEmpresa`,
    consultarTemasDespachoBeta: `${URL_SERVICES}/despacho/consultarTemasDespachoBeta`,
    getExcelEmpresa: `${URL_SERVICES}/despacho/getExcelEmpresa`,
    getExcelEmpresas: `${URL_SERVICES}/despacho/getExcelEmpresas`,
    getExcelInfoVoBo: `${URL_SERVICES}/despacho/getExcelInfoVoBo`,
    getExcelSeleccion: `${URL_SERVICES}/despacho/getExcelSeleccion`,
    consultarTemaAMover: `${URL_SERVICES}/despacho/consultarTemaAMover`,
    moverTemaDespachoAcuerdoMrB: `${URL_SERVICES}/despacho/moverTemaDespachoAcuerdoMrB`,
    quitarTema: `${URL_SERVICES}/despacho/quitarTema`,
    listarEntregables: `${URL_SERVICES}/despacho/listarEntregables`,
    cancelarEntregables: `${URL_SERVICES}/despacho/cancelarEntregables`,
    listarEntradasConSeguimiento: `${URL_SERVICES}/despacho/listarEntradasConSeguimiento`,
    terminarSeguimiento: `${URL_SERVICES}/despacho/terminarSeguimiento`,
    listarEntregablesEnviadosAEjecucion: `${URL_SERVICES}/despacho/listarEntregablesEnviadosAEjecucion`,
    terminarEntregables: `${URL_SERVICES}/despacho/terminarEntregables`,
    agregarTemaDespacho: `${URL_SERVICES}/despacho/agregarTemaDespacho`,
    getInfoDespacho: `${URL_SERVICES}/despacho/getInfoDespacho`,
    editarTemas: `${URL_SERVICES}/despacho/editarTemas`,

  },
  acuerdos: {
    categoria: `${URL_SERVICES}/acuerdos/getCatalogo/CATEGORIA`,
    detalleAcuerdoMR: `${URL_SERVICES}/acuerdos/detalleAcuerdoMR`,
    consultarAcuerdos: `${URL_SERVICES}/acuerdos/consultarAcuerdos`,
    agregarAcuerdo: `${URL_SERVICES}/acuerdos/agregarAcuerdo`,
    guardarTema: `${URL_SERVICES}/acuerdos/guardarTema`,
    relacionarEntrada: `${URL_SERVICES}/acuerdos/relacionarEntrada`,
    notificacion: `${URL_SERVICES}/acuerdos/notificarMensajes`,
    agregarIndicacionesAB: `${URL_SERVICES}/acuerdos/agregarIndicacionesAB`,
    descargaArchivosAcuerdo: `${URL_FUNCTIONS}/descarga/acuerdo`,
    getListaTemas: `${URL_SERVICES}/acuerdos/getListaTemas`,
    editarAcuerdo: `${URL_SERVICES}/acuerdos/editarAcuerdo`,
    consultaEntregables: `${URL_SERVICES}/acuerdos/consultarEntregables`,
    exportAcuerdos: `${URL_SERVICES}/acuerdos/exportAcuerdos`,
    consultarArchivosPorEntrada: `${URL_SERVICES}/acuerdos/consultarArchivosPorEntrada`,
    consultaFechasAcuerdo: `${URL_SERVICES}/acuerdos/consultaFechasAcuerdo`,
    terminarTema: `${URL_SERVICES}/acuerdos/terminarTema`,
    consultarTerminar: `${URL_SERVICES}/acuerdos/consultarJustificacionTerminarTema`,
    moverTemaAcuerdoMrBDespacho: `${URL_SERVICES}/acuerdos/moverTemaAcuerdoMrBDespacho`,
    buscarEntradas: `${URL_SERVICES}/acuerdos/buscarEntradas`,
    eliminarEntrada: `${URL_SERVICES}/acuerdos/eliminarEntrada`,
    exportBitacoraObservaciones: `${URL_SERVICES}/acuerdos/exportBitacoraObservaciones`,
    eliminarArchivoAdjunto : `${URL_FUNCTIONS}/acuerdos/eliminarArchivoAdjunto`,
    aplazarTema: `${URL_SERVICES}/acuerdos/aplazarTema`,
  },
  temas: {
    descargar: `${URL_FUNCTIONS}/descarga/temas`,
  },
  entregables: {
    gas: `https://script.google.com/a/macros/gnp.com.mx/s/AKfycbyFB817oJffIpmI3p-D0pzmVFmmBqsw2K9EAyYWOCAMyDK1QuyXW6VAaBXRJxix1Tz_/exec`,
    bitacora: `${URL_FUNCTIONS}/entregables/bitacora`,
    obtener: `${URL_FUNCTIONS}/entregables/obtener`,
    descarga: `${URL_FUNCTIONS}/descarga/entregable`,
  },
  reportes: {
    consulta: `${URL_FUNCTIONS}/reportes/consulta`,
    descarga: `${URL_FUNCTIONS}/reportes/descarga`,
  },
  tablero: {
    estatus: `${URL_FUNCTIONS}/tablero/obtener`,
    descarga: `${URL_FUNCTIONS}/tablero/descarga`,
  },
  notificaciones: {
    create: `${URL_FUNCTIONS}/notificaciones/create`
  },
  user_supervisor: 'dINYNJMACrWjMWlDvBYnsmGyBbI3'
};
